import { SituationColor } from '@hakimo-ui/hakimo/types';
import clsx from 'clsx';
import { OTHERS_SITUATION_LABEL } from '../constants';

export function createListHandlers<T>(
  items: T[],
  onChange: (items: T[]) => void,
  createEmptyItem: () => T
) {
  const handleAdd = () => {
    const updatedItems = [...items];
    updatedItems.push(createEmptyItem());
    onChange(updatedItems);
  };

  const handleEdit = (index: number, value: T) => {
    const updatedItems = [...items];
    updatedItems[index] = value;
    onChange(updatedItems);
  };

  const handleDelete = (index: number) => {
    const updatedItems = items.filter((_, i) => i !== index);
    onChange(updatedItems);
  };

  return {
    handleAdd,
    handleEdit,
    handleDelete,
  };
}

export function createStringListHandlers(
  items: string[],
  onChange: (items: string[]) => void
) {
  return createListHandlers(items, onChange, () => '');
}

export function getSituationColorClasses(color: SituationColor): string {
  return clsx(
    'dark:bg-ondark-bg-2 bg-onlight-bg-2 border-onlight-line-2 dark:border-ondark-line-2 flex flex-col gap-2 rounded-md border p-2 text-sm',
    color === SituationColor.RED && 'text-rose-600 dark:text-rose-400',
    color === SituationColor.GREEN && 'text-teal-600 dark:text-teal-400',
    color === SituationColor.BLUE && 'text-primary-500 dark:text-primary-400'
  );
}

export function isOthersSituation(label: string): boolean {
  return label.trim().toLowerCase() === OTHERS_SITUATION_LABEL.toLowerCase();
}
